import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormField } from 'src/app/shared/interfaces/form-fields';

@Component({
  selector: 'app-search-filter-desktop',
  templateUrl: './search-filter-desktop.component.html',
  styleUrls: ['./search-filter-desktop.component.scss']
})
export class SearchFilterDesktopComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;
  @Input() searchText: string;
  @Input() formFields: FormField[] = [];
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() applyFilters = new EventEmitter<void>();

  private searchSubject = new Subject<string>();
  private searchSubscription: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {
      this.searchTextChange.emit(value);
      this.applyFilters.emit();
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }

  trackByFieldName(index: number, field: FormField): string {
    return field.name;
  }

  handleSearchTextChange(value: string): void {
    this.searchSubject.next(value);
  }

  triggerFilter(): void {
    this.applyFilters.emit();
  }

}
